import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "../InfoButton/InfoButton.scss"; // uses .global-info-tooltip

export default function TooltipPortal({
  label = "",
  children,
  offsetY = 35,
  offsetX = 0,
}) {
  const wrapRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;

    const place = () => {
      const r = el.getBoundingClientRect();
      setPos({
        top: r.top + window.scrollY - offsetY,
        left: r.left + window.scrollX + r.width / 2 + (offsetX || 0),
      });
    };

    const show = () => {
      place();
      setVisible(true);
      window.addEventListener("scroll", place, { passive: true });
      window.addEventListener("resize", place);
    };

    const hide = () => {
      setVisible(false);
      window.removeEventListener("scroll", place);
      window.removeEventListener("resize", place);
    };

    el.addEventListener("mouseenter", show);
    el.addEventListener("mouseleave", hide);
    el.removeAttribute("title");

    return () => {
      el.removeEventListener("mouseenter", show);
      el.removeEventListener("mouseleave", hide);
      window.removeEventListener("scroll", place);
      window.removeEventListener("resize", place);
    };
  }, [offsetY, offsetX]);

  return (
    <>
      <span
        ref={wrapRef}
        className="tooltip-trigger"
        style={{ display: "inline-flex" }}
      >
        {children}
      </span>

      {createPortal(
        <span
          className={
            "global-info-tooltip" + (visible ? " global-info-tooltip--visible" : "")
          }
          style={{
            top: pos.top,
            left: pos.left,
          }}
        >
          {label}
        </span>,
        document.body
      )}
    </>
  );
}
